"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSsoOnlyAllowedDomainLoginOption = void 0;
var _xor = _interopRequireDefault(require("lodash/xor"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _enums = require("../enums");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var isSsoOnlyAllowedDomainLoginOption = exports.isSsoOnlyAllowedDomainLoginOption = function isSsoOnlyAllowedDomainLoginOption(loginOptions) {
  return (0, _isEmpty["default"])((0, _xor["default"])(loginOptions, [_enums.DOMAIN_LOGIN_OPTIONS.SSO]));
};
//# sourceMappingURL=authentication.js.map